import { Button, CircularProgress } from '@material-ui/core';
import Collapse from "@material-ui/core/Collapse";
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import DescriptionIcon from '@material-ui/icons/Description';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import { DELETE_SP_EVENT_MESSAGE } from 'components/common/constants/Constant';
import React, { useEffect, useState } from 'react';
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { fetchRoadSpecialEventAudioStart } from 'redux/actions/audioPreview.action';
import { fetchRoadSpecialEventsStart, saveRoadSpecialEventsStart } from 'redux/actions/specialEvents.action';
import DeleteAlert from './DeleteAlert';
import DiscardAlert from './DiscardAlert';
import EditorModal from './EditorsModal';
import styles from './RoadCondition.module.scss';
import { PRE_TEMPLATE_TEXT } from './roadConditionConstants';
import SubmitAlertModal from './SubmitAlertModal';


const useStyles = makeStyles({
    root: {
        flexGrow: 1,
    },
    button: {
        textTransform: "none",
        color: '#0fc5d3',
        border: '1px solid #0fc5d3'
    },
    rowMargin: {
        margin: '1%'
    },
});

const SpecialEvent = props => {
    const classes = useStyles();
    const [openIndex, setOpen] = React.useState(-1);
    const [showAll, setShowAll] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const dispatch = useDispatch();
    useEffect(() => { dispatch(fetchRoadSpecialEventsStart()) }, []);
    const roadSpecialEventsState = useSelector((state) => state.roadSpecialEvents);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isNotShowPlayButton, setNotShowPlayButton] = useState({});

    useEffect(() => {
        if (roadSpecialEventsState.roadSpecialEvents) {
            reset({ "events": roadSpecialEventsState.roadSpecialEvents.specialEvents })
        }
    }, [roadSpecialEventsState.roadSpecialEvents, fields]);
    const [openPopOver, setOpenPopOver] = useState(-90);
    const [deletedEvent, setDeletedEvent] = useState([]);
    const [dirtyFieldsList, setDirtyFieldsList] = useState([]);
    const handlePopOverClick = (event, popOverId) => {
        setOpenPopOver(popOverId);
        setAnchorEl(event.currentTarget);
    };

    const roadSpecialEventsAudioState = useSelector((state) => state.audioPreview);
    useEffect(() => {
        if (roadSpecialEventsState && roadSpecialEventsState.isSaved && isSubmitted) {
            props.successToast("Successfully saved special events");
            setIsSubmitted(false);
            reset({});
            setDirtyFieldsList([]);
            setIsDirty(false);
            setShowSubmitAlertModal(false);
            dispatch(fetchRoadSpecialEventsStart())
            onSave();
        }
    }, [roadSpecialEventsState.isSaved]);
    useEffect(() => {
        if (roadSpecialEventsState && roadSpecialEventsState.error && nextTabIndex === 1) {
            props.errorToast(roadSpecialEventsState.error);
            setIsSubmitted(false)
            onSave();
        }
        if (roadSpecialEventsAudioState && roadSpecialEventsAudioState.error && nextTabIndex === 0) {
            props.errorToast(roadSpecialEventsAudioState.error);
        }
    }, [roadSpecialEventsState.error, roadSpecialEventsAudioState.error]);
    const handleClose = () => {
        setAnchorEl(null);
        setOpenPopOver(null);
    };

    const { register, control, handleSubmit, reset, setValue, getValues, formState, watch } = useForm();
    const { fields } = useFieldArray(
        {
            control,
            name: "events"
        }
    );
    const fetchAudio = (textMessage, index, menuOption, isPrompt) => {
        const formValues = getValues();
        if (menuOption != "all" && formValues && formValues.spEvent) {

            formValues.spEvent.map((specialEv) => {
                if (specialEv.menuOption === menuOption) {
                    textMessage = isPrompt ? specialEv.prompt : specialEv.message;
                }
            });
        }
        if (textMessage != "") {
            setAudioIndex(index);
            const indexObj = {};
            indexObj[index] = true;
            setNotShowPlayButton(indexObj);
            dispatch(fetchRoadSpecialEventAudioStart(textMessage));
        }

    }
  
    const handleMessageChange = (event, index, speventMenuOption) => {
        const indexObj = {};
        indexObj[index] = false;
        setNotShowPlayButton(indexObj);
        const dFields = dirtyFieldsList;
        if (dFields.indexOf(speventMenuOption) === -1) {
            dFields.push(speventMenuOption);
        }
        setDirtyFieldsList(dFields);
        setIsDirty(true);
        return event;
    }
    const fetchAllAudio = () => {
        const formValues = getValues();
        let audioText = "";
        if (formValues && formValues.spEvent) {
            formValues.spEvent.map((specialEv) => {
                if (specialEv.prompt && specialEv.prompt.length>0) {
                    let lastChar = specialEv.prompt.substr(specialEv.prompt.length - 1);
                    let lastTwoChar = specialEv.prompt.substr(specialEv.prompt.length - 2);
                    if(lastTwoChar!=". "){
                        if(lastChar!='.'){
                            audioText += specialEv.prompt + ". ";
                        }
                        if(lastChar=='.'){
                            audioText += specialEv.prompt + " ";
                        }
                    }
                    else{
                        audioText += specialEv.prompt;
                    }
                }
            });
            setOpen(-1);
            fetchAudio(audioText, 'showAllEvent', "all", true);
        }
    }
    const onSubmit = (data) => {
        const finalData = [];
        if (data.spEvent) {
            data.spEvent.map(spEv => {
                if ((spEv.message !== undefined && spEv.message?.trim() !== "" && spEv.message != null)
                    && (spEv.prompt !== undefined && spEv.prompt?.trim() !== "" && spEv.prompt != null)) {
                    finalData.push(spEv);
                }
            });
            dispatch(saveRoadSpecialEventsStart({ "specialEvents": finalData }));
        }
        setIsSubmitted(true);
    }
    const [showSubmitAlertModal, setShowSubmitAlertModal] = useState(false);
    const [audioIndex, setAudioIndex] = useState(-1);
    const showSubmitAlert = (data) => {
        setNotShowPlayButton({})
        if (!(roadSpecialEventsState.roadSpecialEvents && roadSpecialEventsState.roadSpecialEvents.specialEvents)) {
            return;
        }
        setDeletedEvent([]);
        setShowSubmitAlertModal(true);
    };
    const onsubmitAlertHide = () => {
        setShowSubmitAlertModal(false);
    }
    const handleUndo = () => {
        document.execCommand('undo', false, null);
    };
    const handleRedo = () => {
        document.execCommand('redo', false, null);
    };
    const handleShowAll = () => {
        setShowAll(true);
        setOpen(-1);
    };
    const handleCollapseAll = () => {
        setShowAll(false);
        setOpen(-1);
    };

    const handleClear = (spMenuOption, index) => {
        let formValues = getValues();
        if (!formValues) return;
        let spObject = {};
        formValues.spEvent.map((spEvent, index) => {
            if (spEvent.menuOption === spMenuOption) {
                spObject.prompt = "";
                spObject.message = "";
                spObject.eventMessage = spEvent.eventMessage;
                spObject.id = spEvent.id;
                spObject.menuOption = spEvent.menuOption;
            }
            return formValues.spEvent;
        })
        setValue("spEvent[" + index + "]", spObject, { shouldDirty: true });
        const dFields = dirtyFieldsList;
        if (dFields.indexOf("Special Event " + spMenuOption) === -1) {
            dFields.push("Special Event " + spMenuOption);
        }
        setDirtyFieldsList(dFields);
        setIsDirty(true);
        setOpen(index);
        handleClose();
    };
    const handlePreTemplate = (ind) => {
        let formValues = getValues();
        if (!formValues) return;
        let spObject = {};
        spObject.prompt = PRE_TEMPLATE_TEXT + formValues.spEvent[ind].menuOption + ". ";
        spObject.message = formValues.spEvent[ind].message;
        spObject.eventMessage = formValues.spEvent[ind].eventMessage;
        spObject.id = formValues.spEvent[ind].id;
        spObject.menuOption = formValues.spEvent[ind].menuOption;
        document.getElementsByName('spEvent[' + ind + '].prompt')[0].focus();
        document.execCommand("selectAll", false);
        document.execCommand("insertText", false, spObject.prompt);

        const dFields = dirtyFieldsList;
        if (dFields.indexOf("Special Event " + formValues.spEvent[ind].menuOption) === -1) {
            dFields.push("Special Event " + formValues.spEvent[ind].menuOption);
        }
        setDirtyFieldsList(dFields);
        setIsDirty(true);
    };
    const [isDirty, setIsDirty] = useState(false);
    useEffect(() => {
        if (!isDirty) {
            props.handleChange(nextTabIndex);
        }
    }, [formState, props.nextTabIndex])
    const onDiscard = () => {
        props.handleChange(nextTabIndex);
        reset({ "events": roadSpecialEventsState?.roadSpecialEvents?.specialEvents })
        setShowModal(false);

    }
    const onSave = () => {
        props.handleChange(nextTabIndex);
        setShowModal(false)
    }
    const onHide = () => {
        props.handleChange(1);
        setShowModal(false)
    }
    const [showDiscardModal, setShowDiscardModal] = useState(false);
    const onDiscardYes = () => {
        setShowDiscardModal(false); setNotShowPlayButton({});
        dispatch(fetchRoadSpecialEventsStart())
        setIsDirty(false);
        setDirtyFieldsList([]);
    }
    const onDiscardNo = () => {
        setShowDiscardModal(false); setNotShowPlayButton({})
    }
    const onDiscardHide = () => {
        setShowDiscardModal(false); setNotShowPlayButton({})
    }
    const [deleteMenuOption, setDeleteMenuOption] = useState({});
    const handleDelete = (index, menuOption) => {
        setShowDeleteModal(true);
        setDeleteMenuOption({ "index": index, "menuOption": menuOption });
        handleClose();
    };
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const onDeleteDiscard = () => {
        setShowDeleteModal(false);
        setDeleteMenuOption({});
    }
    const onDeleteSave = () => {
        let formValues = getValues();
        if (!formValues) return;

        formValues.spEvent.map((spEvent, index) => {
            if (spEvent.menuOption >= deleteMenuOption.menuOption) {
                if (formValues.spEvent.length <= index + 1) {
                    let spObject = {};
                    spObject.prompt = '';
                    spObject.message = '';
                    spObject.eventMessage = '';
                    spObject.id = formValues.spEvent[index].id;
                    spObject.menuOption = 8;
                    setValue("spEvent[" + index + "]", spObject, { shouldDirty: true });
                }
                else {
                    let spObject = {};
                    let prompt = formValues.spEvent[index + 1].prompt ? formValues.spEvent[index + 1].prompt : '';
                    const pressIndex = prompt.indexOf('press');
                    prompt = pressIndex !== -1 ? prompt.substring(0, pressIndex) + 'press ' + (index + 1) + prompt.substring(pressIndex + 7) : prompt;
                    spObject.prompt = prompt;
                    spObject.message = formValues.spEvent[index + 1].message;
                    spObject.eventMessage = formValues.spEvent[index + 1].eventMessage;
                    spObject.id = formValues.spEvent[index + 1].id;
                    spObject.menuOption = formValues.spEvent[index].menuOption;
                    setValue("spEvent[" + index + "]", spObject, { shouldDirty: true });
                }

            }
            return formValues.spEvent;
        })

        const dFields = dirtyFieldsList;
        if (dFields.indexOf("Special Event " + deleteMenuOption.menuOption) === -1) {
            dFields.push("Special Event " + deleteMenuOption.menuOption);
        }
        setDirtyFieldsList(dFields);
        setIsDirty(true);
        setShowDeleteModal(false);
        setDeleteMenuOption({});
    }
    const onDeleteHide = () => {
        setShowDeleteModal(false);
        setDeleteMenuOption({});
    }
    const [showModal, setShowModal] = useState(false);
    const [nextTabIndex, setNextTabIndex] = useState(props.nextTabIndex);
    useEffect(() => {
        if (!(roadSpecialEventsState.roadSpecialEvents && roadSpecialEventsState.roadSpecialEvents.specialEvents)) {
            return;
        }
        setShowModal(true);
        setDeletedEvent([]);
        setNextTabIndex(props.nextTabIndex);
    }, [props.nextTabIndex]);

    return (
        <div>
            <>
                <form onSubmit={handleSubmit(showSubmitAlert)}>
                    {showDeleteModal &&
                        <DeleteAlert
                            onSave={onDeleteSave}
                            onDiscard={onDeleteDiscard}
                            onHide={onDeleteHide}
                            show={showDeleteModal}
                            modalMessage={DELETE_SP_EVENT_MESSAGE}
                            modalBody={["Special event " + deleteMenuOption.menuOption]} />
                    }
                    {nextTabIndex !== 1 && showModal && isDirty &&
                        <EditorModal
                            onSave={handleSubmit(onSubmit)}
                            onDiscard={onDiscard}
                            onHide={onHide}
                            show={showModal}
                            modalTitle="You have made changes to the following special events. Would you like to submit these changes?"
                            modalBody={dirtyFieldsList} />}
                    {props.nextTabIndex === 1 && showSubmitAlertModal && isDirty &&
                        <SubmitAlertModal
                            onSave={handleSubmit(onSubmit)}
                            onDiscard={onsubmitAlertHide}
                            onHide={onsubmitAlertHide}
                            show={showSubmitAlertModal}
                            modalBody={dirtyFieldsList}
                            modalTitle=" Special events Update"
                            modalMessage="You have made changes to the following special events. Would you like to submit these changes?"
                        />
                    }
                    {showDiscardModal &&
                        <DiscardAlert
                            onYes={onDiscardYes}
                            onCancel={onDiscardNo}
                            onHide={onDiscardHide}
                            show={showDiscardModal}
                            modalBody={"Discard All Changes ? "} />
                    }
                    {roadSpecialEventsState.loading ?
                        <div className={" row " + styles.minh40 + " " + styles.loader}><CircularProgress fontSize="large" /></div> : <>
                            <div className={styles.topSubmitRow + " row"}>
                                <div className={"col col-md-12 col-xs-12 " + styles.rightAlign}>
                                    <Button title="Submit Changes" disabled={!isDirty} className={isDirty ? styles.submitButton : styles.disableButton} variant="contained" color="primary" type="Submit">Submit</Button>
                                    <span style={{ padding: '5px' }}></span>
                                    <Button disabled={!isDirty} className={isDirty ? styles.cancelButton : styles.disableButton} variant="outlined" color="secondary" onClick={() => setShowDiscardModal(true)}>Cancel</Button>
                                </div>
                            </div>
                            <div className={styles.rowEnd}></div>
                            <div className={styles.mt50 + " " + classes.rowMargin + " " + styles.spEventRow}>

                                <div className={styles.topGap} ><h2>Special Events Menu Options</h2></div>
                                <div style={{ display: "flex", marginBottom: "2%" }}>
                                    <span>Last Updated Date: </span>
                                    <span style={{ marginLeft: "2%" }}>{roadSpecialEventsState?.roadSpecialEvents?.specialEvents[0].lastModifiedDateTime ? roadSpecialEventsState?.roadSpecialEvents?.specialEvents[0].lastModifiedDateTime.replace('T', ' ').substring(0, 16) : ''}</span>
                                    <div style={{ marginLeft: "auto" }}></div>
                                    <div >
                                        <Button style={{ marginLeft: "auto" }} variant="text" onClick={handleCollapseAll}>Collapse all </Button>
                                        <Button variant="text" onClick={handleShowAll}>Show all </Button>
                                    </div>
                                </div>
                            </div>
                            {
                                fields.map((spEvent, index) => (
                                    <div key={spEvent.menuOption + index} >
                                        <div className={styles.spEventRow + " " + styles.border}>
                                            <Controller
                                                as={<input
                                                    readOnly
                                                    hidden
                                                    className={styles.noBorder}
                                                    rows={1}
                                                    value={spEvent.menuOption}
                                                    name={`spEvent[index].menuOption`}
                                                    ref={register}
                                                />}
                                                name={`spEvent[${index}].menuOption`}
                                                control={control}
                                                defaultValue={spEvent.menuOption}
                                            />

                                            <div className={styles.mt50 + " row " + classes.rowMargin} style={{ marginLeft: "0", marginRight: "0" }}>
                                                <div className="col-md-10 col-sm-10">

                                                    {openIndex === index && openIndex !== -1 ?
                                                        (<ArrowDropUpIcon className={styles.downUpArrow} onClick={() => setOpen(-1)}></ArrowDropUpIcon>) :
                                                        (<ArrowDropDownIcon className={styles.downUpArrow} onClick={() => setOpen(index)}></ArrowDropDownIcon>)}
                                                    <span>{index + 1}: {watch(`spEvent[${index}].prompt`, spEvent.prompt)}</span>
                                                </div>
                                                <div className={"col col-md-2 col-sm-2 " + styles.rightAlign}>
                                                    <Button color="primary" onClick={() => handleClear(spEvent.menuOption, index)}>Clear</Button>
                                                    <Button color="primary" onClick={() => handleDelete(index, spEvent.menuOption)}>Delete</Button>

                                                </div>
                                            </div>
                                            <Collapse in={showAll ? true : openIndex === index} style={{ display: "block" }}>
                                                <div className={styles.h120 + " row " + classes.rowMargin}>
                                                    <div className={" col-md-12 col-xs-12"}>
                                                        <strong>{index + 1}: Prompt</strong>
                                                    </div>
                                                    <div className={"col-md-12 col-xs-12"}>
                                                        <div className={styles.colorBorder}>
                                                            <Toolbar className={styles.border} style={{ background: "#f0f3f4", minHeight: "63px", padding: "0" }}>
                                                                <div className={"row " + styles.w100}>
                                                                    <div className={"col-xs-4 col-md-4 " + styles.middleAlign}>
                                                                        <> <Button title="Insert default prompt message"><DescriptionIcon style={{ color: "#c60c30", fontSize: "30px" }} onClick={() => handlePreTemplate(index)} /></Button></>
                                                                    </div>
                                                                    <div className={"col-xs-8 col-md-8 " + styles.rightAlign}>
                                                                        {!isNotShowPlayButton[index] ? <Button title="Preview Audio" onClick={() => fetchAudio("", index, spEvent.menuOption, true)} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                                                            (index === audioIndex && roadSpecialEventsAudioState.loading ? <CircularProgress /> :
                                                                                <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                                                    <source src={index === audioIndex ? roadSpecialEventsAudioState.audioResponse : "ok"} type="audio/wav" ></source>
                                                                                </audio>)}
                                                                    </div>
                                                                </div>
                                                            </Toolbar>
                                                            <Controller
                                                                render={(props) => (
                                                                    <TextField
                                                                        {...props}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: styles.fs14,
                                                                            },
                                                                        }}
                                                                        multiline
                                                                        fullWidth
                                                                        rows={5}
                                                                        color="primary"
                                                                        ref={register}
                                                                        onChange={(value) => {
                                                                            props.onChange(value);
                                                                            handleMessageChange(value, index, "Special Event " + spEvent.menuOption);
                                                                        }}
                                                                        value={props.value}
                                                                    />
                                                                )}
                                                                name={`spEvent[${index}].prompt`}
                                                                control={control}
                                                                defaultValue={spEvent.prompt ? spEvent.prompt : ''}
                                                            />
                                                        </div>
                                                    </div>

                                                </div>

                                                <div className={styles.h120 + " row " + classes.rowMargin}>
                                                    <div className={styles.mt50 + " col-md-12 col-xs-12"}>
                                                        <strong>{index + 1}: Event Message</strong>
                                                    </div>
                                                    <div className={"col-md-12 col-xs-12"}>
                                                        <div className={styles.colorBorder}>
                                                            <Toolbar className={styles.border} style={{ background: "#f0f3f4", minHeight: "63px", padding: "0" }}>
                                                                <div className={"row " + styles.w100}>
                                                                    <div className={"col-xs-12 col-md-12 " + styles.rightAlign}>
                                                                        {!isNotShowPlayButton[index + 'Event'] ? <Button title="Preview Audio" onClick={() => fetchAudio("", index + 'Event', spEvent.menuOption, false)} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                                                            (index + 'Event' === audioIndex && roadSpecialEventsAudioState.loading ? <CircularProgress /> :
                                                                                <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                                                    <source src={index + 'Event' === audioIndex ? roadSpecialEventsAudioState.audioResponse : "ok"} type="audio/wav" ></source>
                                                                                </audio>)}
                                                                    </div>
                                                                </div>

                                                            </Toolbar>
                                                            <Controller
                                                                render={(props) => (
                                                                    <TextField
                                                                        {...props}
                                                                        variant="outlined"
                                                                        InputProps={{
                                                                            classes: {
                                                                                input: styles.fs14,
                                                                            },
                                                                        }}
                                                                        multiline
                                                                        fullWidth
                                                                        rows={5}
                                                                        color="primary"
                                                                        ref={register}
                                                                        onChange={(value) => {
                                                                            props.onChange(value);
                                                                            handleMessageChange(value, index + "Event", "Special Event " + spEvent.menuOption);
                                                                        }}
                                                                        value={props.value}
                                                                    />
                                                                )}
                                                                name={`spEvent[${index}].message`}
                                                                control={control}
                                                                defaultValue={spEvent.message ? spEvent.message : ''}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </Collapse>
                                        </div>

                                    </div>))
                            }
                            <div className={styles.topSubmitRow + " row " + styles.mt2}>

                                <div className={" col col-md-12 col-xs-12  "}>
                                    <h3 style={{ display: "inline-block", marginLeft: "20px" }}>Preview Special Events Menu</h3>

                                    {!isNotShowPlayButton['showAllEvent'] ? <Button title="Preview Audio" onClick={fetchAllAudio} > <PlayCircleFilledIcon style={{ color: "#c60c30", fontSize: "30px" }} /></Button> :
                                        ('showAllEvent' === audioIndex && roadSpecialEventsAudioState.loading ? <CircularProgress /> :
                                            <audio controls autoPlay style={{ top: "3px", position: "relative", width: "100%" }}>
                                                <source src={'showAllEvent' === audioIndex ? roadSpecialEventsAudioState.audioResponse : "ok"} type="audio/wav" ></source>
                                            </audio>)}
                                </div>
                            </div>
                            <div className={styles.topSubmitRow + " row"}>
                                <div className="col col-md-5 col-xs-5"></div>
                                <div className={"col col-md-7 col-xs-7 " + styles.rightAlign}>
                                    <Button title="Submit Changes" disabled={!isDirty} className={isDirty ? styles.submitButton : styles.disableButton} variant="contained" color="primary" type="Submit">Submit</Button>
                                    <span style={{ padding: '5px' }}></span>
                                    <Button disabled={!isDirty} className={isDirty ? styles.cancelButton : styles.disableButton} variant="outlined" color="secondary" onClick={() => setShowDiscardModal(true)}>Cancel</Button>
                                </div>
                            </div>

                        </>}
                </form>
            </>
        </div>
    );
}

export default withRouter(props => <SpecialEvent {...props} />);